module.exports = __webpack_public_path__ + "static/fonts/OptimaMedium.19cfff9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/font/OptimaMedium.ttf
// module id = 976
// module chunks = 113